import { type LevelProgressCoachComment } from '@/lib/types';
import { IconButton } from '@mui/material';
import { useContext, useState } from 'react';
import HtmlRenderer from '@/components/ChallengePortfolio/NormalView/portfolio-item/PortfolioItemFields/FieldRenderer/TypeSpecificFieldRenderers/utils/HtmlRenderer';
import CommentUser from '@/components/comment/CommentUser';
import CommentHeader from '@/components/comment/CommentHeader';
import CommentActionsWrapper from '@/components/comment/CommentActionsWrapper';
import RestrictedToPortfolioMode from '@/components/RestrictedToPortfolioMode';
import PortfolioMode from '@/lib/constants/PortfolioMode.enum';
import { Edit as EditIcon } from '@mui/icons-material';
import CommentWrapper from '@/components/comment/CommentWrapper';
import DeleteLevelProgressCoachComment from './DeleteLevelProgressCoachComment';
import LevelProgressCoachCommentEditor from './LevelProgressCoachComment';
import IsNewCommentIndicator from '@/components/comment/IsNewCommentIndicator';
import PortfolioIsReadOnlyContext from '@/lib/contexts/PortfolioIsReadOnlyContext';

type LevelProgressCoachCommentProps = {
  levelProgressCoachComment: LevelProgressCoachComment;
};

const LevelProgressCoachComment = ({
  levelProgressCoachComment,
}: LevelProgressCoachCommentProps) => {
  const [editing, setEditing] = useState(false);

  const portfolioIsReadonly = useContext(PortfolioIsReadOnlyContext);

  return (
    <CommentWrapper>
      <CommentHeader>
        <CommentUser
          user={levelProgressCoachComment.author}
          createdAt={levelProgressCoachComment.createdAt}
        />
        <RestrictedToPortfolioMode mode={PortfolioMode.STUDENT}>
          {!levelProgressCoachComment.isRead && <IsNewCommentIndicator />}
        </RestrictedToPortfolioMode>
        {!editing && !portfolioIsReadonly && (
          <RestrictedToPortfolioMode mode={PortfolioMode.COACH}>
            <CommentActionsWrapper>
              <IconButton onClick={() => setEditing(true)} size="small">
                <EditIcon fontSize="small" />
              </IconButton>
              <DeleteLevelProgressCoachComment
                levelProgressCoachComment={levelProgressCoachComment}
              />
            </CommentActionsWrapper>
          </RestrictedToPortfolioMode>
        )}
      </CommentHeader>
      {editing ? (
        <LevelProgressCoachCommentEditor
          levelProgressCoachComment={levelProgressCoachComment}
          onClose={() => setEditing(false)}
        />
      ) : (
        <HtmlRenderer source={levelProgressCoachComment.content} darkText />
      )}
    </CommentWrapper>
  );
};

export default LevelProgressCoachComment;
